<div class="form-fill-error-container flex flex-column align-items-center justify-content-center p-6">
    <div class="error-content text-center max-w-30rem">
        <div class="error-icon-wrapper mb-4">
            <i [class]="errorIcon + ' ' + errorIconColor" style="font-size: 4rem;">
            </i>
        </div>

        <h2 class="error-title text-2xl font-bold mb-3 text-900">
            {{ errorTitle }}
        </h2>

        <p class="error-message text-lg mb-4 text-600 line-height-3">
            {{ errorMessage }}
        </p>
    </div>
</div>